export default {"src":"/_next/static/media/logo_mediawind.dd7d88a7.svg","height":47,"width":78,"blurWidth":0,"blurHeight":0};